import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const TIMEOUT_MS = 8000;

// Al llegar con ?ref=<id>[,<id2>] desde la Bitácora, busca el registro en pantalla, lo centra y lo resalta.
export const useReferenceHighlight = () => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const ref = params.get('ref');
    if (!ref) return undefined;
    const ids = ref.split(',').filter(Boolean);
    if (ids.some((id) => pathname.includes(id))) { // la página misma es la referencia (detalle)
      params.delete('ref'); navigate({ pathname, search: params.toString() ? `?${params}` : '' }, { replace: true });
      return undefined;
    }
    const started = Date.now();
    let timer;

    const cleanUrl = () => { params.delete('ref'); navigate({ pathname, search: params.toString() ? `?${params}` : '' }, { replace: true }); };
    const attempt = () => {
      for (const id of ids) {
        const el = document.querySelector(`[data-focus-id*="${CSS.escape(id)}"]`) || document.querySelector(`[data-testid*="${CSS.escape(id)}"]`);
        if (el) {
          const target = el.closest('tr') || el.closest('[data-focus-id]') || el.closest('[data-testid]') || el;
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          target.classList.add('ref-highlight');
          target.setAttribute('data-ref-highlight', 'true');
          setTimeout(() => target.classList.remove('ref-highlight'), 6000);
          cleanUrl();
          return;
        }
      }
      if (Date.now() - started < TIMEOUT_MS) timer = setTimeout(attempt, 300);
      else { toast.info('No se encontró el registro en pantalla (puede estar en otro filtro o periodo)'); cleanUrl(); }
    };
    timer = setTimeout(attempt, 400);
    return () => clearTimeout(timer);
  }, [pathname, search, navigate]);
};

export const ReferenceHighlight = () => { useReferenceHighlight(); return null; };
export default ReferenceHighlight;
